import { render, staticRenderFns } from "./TreatmentItemsInputPopup.vue?vue&type=template&id=6c7c0d52&scoped=true&"
import script from "./TreatmentItemsInputPopup.vue?vue&type=script&lang=js&"
export * from "./TreatmentItemsInputPopup.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentItemsInputPopup.vue?vue&type=style&index=0&id=6c7c0d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7c0d52",
  null
  
)

export default component.exports